import * as Yup from 'yup';

export const employeePortalSectionSchema = Yup.object().shape({
  flags: Yup.array().default(['SHOW_IN_TEAMROSTER'])
});
